import { useQuery } from "react-query";
import { BookingEngineService } from "../../../services/bookingEngine/bookingEngine.service";
export var useBookingEngineConfigs = function (sectorIds) {
    var _a;
    var query = useQuery({
        queryKey: ['bookingEngineConfigs', sectorIds],
        queryFn: function () {
            return BookingEngineService.list({
                limit: {
                    offset: 0,
                    limit: 1000,
                    sort: [{ field: "name", direction: "ASC" }]
                },
                sectorIds: sectorIds
            });
        },
        enabled: !!sectorIds
    });
    return ((_a = query.data) === null || _a === void 0 ? void 0 : _a.content) || [];
};
export var useBookingEngines = function () {
    var _a;
    var query = useQuery({
        queryKey: ['bookingEngines'],
        queryFn: function () {
            return BookingEngineService.list({
                limit: {
                    offset: 0,
                    limit: 1000,
                    sort: [{ field: "name", direction: "ASC" }]
                }
            });
        }
    });
    return ((_a = query.data) === null || _a === void 0 ? void 0 : _a.content) || [];
};
